import { PaymentOption, QuoteDetails } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedQuoteConfirmation } from '../checkout-completed-item/checkout-completed-quote-confirmation.interface';

export interface CompletedQuoteDetails
  extends QuoteDetails,
    CheckoutCompletedQuoteConfirmation {
  purchasedPaymentOption: PaymentOption;
}
